<div class="tabs-container">
    <div class="tab" [class.active]="!displayArchived" (click)="displayActiveCompanies()">
        <span> {{ 'aumico_companies_activate_state' | i18next }}</span
        ><span hamBadge [color]="activeColor">{{ activeCompanyNumber }}{{ activeLicenses }}</span>
    </div>
    <div class="tab" [class.active]="displayArchived" (click)="displayArchivedCompanies()">
        <span> {{ 'aumico_companies_inactivate_state' | i18next }}</span
        ><span hamBadge [color]="inactiveColor">{{ archivedCompanyNumber }}</span>
    </div>
</div>
<div *ngIf="isInTrialMode" class="status-banner">
    <!-- Icon -->
    <span class="ham-icon icon">
        <i class="exclamation-outline-icon"></i>
    </span>

    <!-- Text -->
    <div class="banner-text">{{ trialMessage }}</div>
</div>
<div *ngIf="isSuspended" class="status-banner">
    <!-- Icon -->
    <span class="ham-icon icon">
        <i class="exclamation-outline-icon"></i>
    </span>

    <!-- Text -->
    <div class="banner-text">{{ 'aumico_licence_banner_suspended' | i18next }}</div>
</div>
<div *ngIf="isChurned && churnDate" class="status-banner">
    <!-- Icon -->
    <span class="ham-icon icon">
        <i class="exclamation-outline-icon"></i>
    </span>

    <!-- Text -->
    <div class="banner-text">{{ churnedMessage }}</div>
</div>
<app-licence-banner
    *ngIf="!isLicenseBannerDismissed && status?.available <= 0"
    [status]="status"
    (requestMore)="requestMoreLicences()"
    (dismiss)="dismissWarning()"
></app-licence-banner>

<div *ngIf="isBulkCreateInProgress" class="bulk-create-progress-banner">
    <div class="progress-info">
        <span class="ham-icon">
            <i class="clock-outline-icon"></i>
        </span>
        <span class="progress-title">{{ 'aumico_companies_bulk_create_processing' | i18next }}</span>
        <span class="progress-count" *ngIf="bulkCreateJobStatus">
            {{
                'aumico_companies_bulk_create_processing_status'
                    | i18next
                        : {
                              processed: bulkCreateJobStatus.processedCompanies,
                              total: bulkCreateJobStatus.totalCompanies
                          }
            }}
        </span>
    </div>
    <div class="progress-bar-container">
        <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="bulkCreateProgress"></div>
        </div>
        <div class="progress-text">{{ bulkCreateProgress }}%</div>
    </div>
</div>

<div class="page-wrapper" #pageWrapper>
    <div class="page-header" [style]="'min-width: 700px;'">
        <form [formGroup]="searchForm" (ngSubmit)="filterItems()">
            <input
                hamInput
                icon="/assets/hamIcons/search-outline.svg"
                formControlName="searchTerm"
                placeholder="{{ 'aumico_companies_table_search_button' | i18next }}"
                (cancel)="resetFilter()"
                [shouldHighliteBlueWhenValueEntered]="true"
            />
        </form>
        <div class="d-flex">
            <user-filter-drop-down
                [label]="'aumico_companies_list_filter_mandate_manager' | i18next"
                [users]="searchedMandateManagersOptions"
                [selectedUserIds]="companiesFilter?.mandateManagerIds || []"
                [currentUserId]="currentUserId"
                [view]="'companies'"
                (userChange)="onMandateManagerFilterChange($event)"
                (searchChange)="onSearchFilterChangeMandateManager($event)"
            ></user-filter-drop-down>
            <user-filter-drop-down
                [label]="'aumico_companies_list_filter_clerk' | i18next"
                [users]="searchedMandateManagersOptions"
                [selectedUserIds]="companiesFilter?.clerkIds || []"
                [currentUserId]="currentUserId"
                [view]="'companies'"
                (userChange)="onClerkFilterChange($event)"
                (searchChange)="onSearchFilterChangeClerk($event)"
            ></user-filter-drop-down>

            <!-- REV-22155: tag filter, same dropdown as the user filters, without the initials circle. -->
            <user-filter-drop-down
                *ngIf="tags.length > 0"
                data-testid="companies-filter-tag"
                [label]="'aumico_tags_box_title' | i18next"
                [users]="tagOptions"
                [selectedUserIds]="tagFilterIds"
                [showAvatar]="false"
                [view]="'companies'"
                (userChange)="onTagFilterChange($event)"
                (searchChange)="onSearchFilterChangeTag($event)"
            ></user-filter-drop-down>

            <ham-button
                [variant]="'white'"
                icon="assets/hamIcons/arrow-down-to-bracket-outline.svg"
                (buttonClick)="onExportToXLSX()"
            >
                {{ 'aumico_companies_table_download_xls' | i18next }}
            </ham-button>

            <ham-button
                icon="assets/hamIcons/plus-outline.svg"
                type="submit"
                (buttonClick)="onNew()"
                [disabled]="!canCreate"
                [hamDisabledTooltip]="'aumico_licence_tooltip_no_license' | i18next"
            >
                {{ 'aumico_companies_table_new_button' | i18next }}
            </ham-button>
        </div>
    </div>
    <div class="page-content">
        <ham-table-with-actions
            *ngIf="filteredData?.length > 0"
            [dataSource]="filteredData"
            [pagination]="false"
            (rowSelected)="onRowButtonClicked($event)"
            [columnClasses]="columnClasses"
            [tableStyles]="'overflow-x: auto;'"
            hideActions="true"
            [tableStyles]="'min-width: 700px; table-layout: fixed'"
        >
            <tr groupHeaderRow class="group-header-row">
                <th class="hamScaleColLarge">
                    <div style="display: flex; align-items: center">
                        <span
                            *ngIf="!displayArchived"
                            class="checkbox-wrapper"
                            style="padding: 10px; cursor: pointer; display: inline-flex; align-items: center"
                            (click)="$event.stopPropagation(); onToggleCheckAllCompanies(); $event.stopPropagation()"
                        >
                            <span hamCheckbox [checked]="allCompaniesSelected" (change)="onToggleCheckAllCompanies()">
                            </span>
                        </span>
                        {{ 'aumico_companies_table_label_company_name' | i18next }}
                    </div>
                </th>
                <th class="hamScaleColSmall">
                    {{ 'aumico_companies_table_label_company_street_and_number' | i18next }}
                </th>
                <th class="hamTextCol150">{{ 'aumico_companies_table_label_company_postal_code' | i18next }}</th>
                <th class="hamTextCol150">{{ 'aumico_companies_table_label_company_location' | i18next }}</th>
                <!-- REV-22155: tag column instead of the workflow column, only when the organization has tags -->
                <th *ngIf="tags.length > 0" class="hamTextCol150">{{ 'aumico_tags_box_title' | i18next }}</th>
                <th class="hamScaleColResponsible">{{ 'aumico_companies_list_filter_mandate_manager' | i18next }}</th>
                <th class="hamScaleColResponsible">{{ 'aumico_companies_list_filter_clerk' | i18next }}</th>
                <!-- Sticky action column -->
            </tr>
            <ng-template hamCell let-element>
                <div
                    style="display: flex; align-items: center"
                    [ngClass]="{ selected: selectedCompanies.has(element._id) }"
                >
                    <span
                        *ngIf="!displayArchived"
                        class="checkbox-wrapper"
                        style="padding: 10px; cursor: pointer; display: flex; align-items: center"
                        (click)="onCompanyCheckboxClick(element._id, $event)"
                    >
                        <span
                            class="checkBox"
                            hamCheckbox
                            [checked]="selectedCompanies.has(element._id)"
                            [bubbleEvents]="true"
                        >
                        </span>
                    </span>
                    <div class="company-name">
                        <span #nameCell class="company-name-text" [hamTooltip]="null">
                            {{ element?.name || '-' }}
                        </span>
                        <span class="badge" *ngIf="element.label">
                            <ng-container>
                                <span>{{ element.label }}</span>
                            </ng-container>
                        </span>
                    </div>
                </div>
            </ng-template>

            <ng-template hamCell let-element>
                <span
                    #streetCell
                    class="truncate-text"
                    [hamTooltip]="streetCell.scrollWidth > streetCell.clientWidth ? element?.street : null"
                >
                    {{ element?.street || '-' }}
                </span>
            </ng-template>
            <ng-template hamCell let-element> {{ element?.zip || '-' }} </ng-template>
            <ng-template hamCell let-element> {{ element?.location || '-' }} </ng-template>
            <!-- REV-22155: tags as pills, display only (no "×"). -->
            <ng-template hamCell let-element *ngIf="tags.length > 0">
                <div class="tag-cell">
                    <ham-tag-pill *ngFor="let tagName of element?.tagNames" [label]="tagName"></ham-tag-pill>
                </div>
            </ng-template>
            <ng-template hamCell let-element>
                <div class="dropdown-wrapper assignee">
                    <ham-button
                        #assigneeButtonWrapper
                        class="assignee-button"
                        size="xs"
                        variant="white"
                        (buttonClick)="openAssigneeFlyout(element._id, assigneeButtonWrapper)"
                        (click)="$event.stopPropagation()"
                    >
                        <span class="inner-assignee-wrapper">
                            <span class="avatar_and_name">
                                <span class="avatar" [class.deleted]="element.assigneeDeleted">{{
                                    getInitials(element.assignee || 'aumico_tasks_unassigned' | i18next)
                                }}</span>
                                <span class="name-display" [class.deleted]="element.assigneeDeleted">{{
                                    element.assignee || 'aumico_tasks_unassigned' | i18next
                                }}</span>
                            </span>
                            <span>
                                <span class="ham-icon">
                                    <i class="chevron-down-icon"></i>
                                </span>
                            </span>
                        </span>
                    </ham-button>
                </div>

                <span
                    class="menu-flyout"
                    hamFlyout
                    *ngIf="openedAssigneeFlyoutCompanyId === element._id"
                    [position]="flyoutPosition"
                    (closeFlyout)="closeAssigneeFlyout()"
                >
                    <div class="flyout-user-options-content">
                        <div
                            *ngFor="let assignee of organizationUsers"
                            class="status-option assignee"
                            [class.selected]="element.assignee === assignee.name"
                            (click)="confirmAssigneeChange(element, assignee.id); $event.stopPropagation()"
                        >
                            <span class="avatar">{{ getInitials(assignee?.name || '') }}</span>
                            <span class="name">{{ assignee?.name || ('aumico_tasks_unassigned' | i18next) }}</span>
                        </div>
                    </div>
                </span>
            </ng-template>
            <ng-template hamCell let-element>
                <div class="dropdown-wrapper assignee">
                    <ham-button
                        #clerkButtonWrapper
                        class="assignee-button"
                        size="xs"
                        variant="white"
                        (buttonClick)="openClerkFlyout(element._id, clerkButtonWrapper)"
                        (click)="$event.stopPropagation()"
                    >
                        <span class="inner-assignee-wrapper">
                            <span class="avatar_and_name">
                                <span class="avatar" [class.deleted]="element.clerkDeleted">{{
                                    getInitials(element.clerk || 'aumico_tasks_unassigned' | i18next)
                                }}</span>
                                <span class="name-display" [class.deleted]="element.clerkDeleted">{{
                                    element.clerk || 'aumico_tasks_unassigned' | i18next
                                }}</span>
                            </span>
                            <span>
                                <span class="ham-icon">
                                    <i class="chevron-down-icon"></i>
                                </span>
                            </span>
                        </span>
                    </ham-button>
                </div>

                <span
                    class="menu-flyout"
                    hamFlyout
                    *ngIf="openedClerkFlyoutCompanyId === element._id"
                    [position]="flyoutPosition"
                    (closeFlyout)="closeClerkFlyout()"
                >
                    <div class="flyout-user-options-content">
                        <div
                            *ngFor="let assignee of organizationUsers"
                            class="status-option assignee"
                            [class.selected]="element.clerk === assignee.name"
                            (click)="confirmClerkChange(element, assignee.id); $event.stopPropagation()"
                        >
                            <span class="avatar">{{ getInitials(assignee?.name || '') }}</span>
                            <span class="name">{{ assignee?.name || ('aumico_tasks_unassigned' | i18next) }}</span>
                        </div>
                    </div>
                </span>
            </ng-template>
        </ham-table-with-actions>
        <div class="empty-state-wrapper" *ngIf="!(filteredData?.length > 0)">
            <div class="empty-state">
                <span
                    class="file-circle-plus-outline-wrapper"
                    hamIconShapes
                    icon="assets/hamIcons/building.svg"
                    [size]="'50px'"
                >
                </span>
                <div class="text1">
                    {{ 'aumico_companies_empty_state_text1' | i18next }}
                </div>
                <div class="text2" [innerHTML]="'aumico_companies_empty_state_text2' | i18next"></div>
                <ham-button
                    type="submit"
                    [disabled]="!canCreate"
                    icon="assets/hamIcons/plus-outline.svg"
                    (buttonClick)="onNew()"
                >
                    {{ 'aumico_companies_table_new_button' | i18next }}
                </ham-button>
            </div>
        </div>
    </div>
</div>
<ham-modal
    *ngIf="showConfirmationDialog"
    (cancel)="showConfirmationDialog = false"
    [size]="'sm'"
    [showCancelButton]="true"
    [cancelText]="'aumico_licence_banner_dialog_close_button' | i18next"
>
    <div class="flex-center">
        <span
            hamIconShapes
            class="user-headset-icon"
            icon="assets/hamIcons/user-headset.svg"
            [variant]="'yellow'"
            [size]="'lg'"
            [type]="'square'"
        ></span>

        <span class="ham-icon">
            <i class="user-headset-icon"></i>
        </span>

        <h3>{{ 'aumico_licence_banner_dialog_title' | i18next }}</h3>
        <p>{{ 'aumico_licence_banner_dialog_text' | i18next }}</p>
        <p>
            <i>{{ 'aumico_license_book_call_text' | i18next }}</i>
        </p>
        <ham-button class="call-button" (buttonClick)="bookCall()" type="submit"
            >{{ 'aumico_license_book_call_button' | i18next }}
        </ham-button>
    </div>
</ham-modal>

<ham-modal
    *ngIf="openClerkChangeConfirmationDialog"
    (cancel)="closeClerkChangeConfirmationDialog()"
    [saveText]="'aumico_company_assignee_change_confirmation_dialog_save_button' | i18next"
    (save)="updateClerk()"
    [size]="'default'"
    [showCancelButton]="true"
    [cancelText]="'aumico_licence_banner_dialog_close_button' | i18next"
>
    <div class="flex-start task-reassignment">
        <h3>{{ 'aumico_company_assignee_change_confirmation_dialog_title' | i18next }}</h3>
        <span class="description">
            {{ 'aumico_company_assignee_change_confirmation_dialog_text' | i18next }}
        </span>

        <label class="option-card" (click)="selectedTaskUpdate = tasksUpdate.UPDATE_TASKS_ASSIGNED_TO_CURRENT">
            <div class="content">
                <div class="title">
                    {{ 'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user' | i18next }}
                </div>
                <div class="description">
                    {{
                        'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text'
                            | i18next
                    }}
                </div>
            </div>
            <input type="radio" name="task-reassignment" checked />
        </label>

        <label class="option-card" (click)="selectedTaskUpdate = tasksUpdate.UPDATE_ALL_TASKS">
            <div class="content">
                <div class="title">{{ 'aumico_company_assignee_change_confirmation_update_all_tasks' | i18next }}</div>
                <div class="description">
                    {{ 'aumico_company_assignee_change_confirmation_update_all_tasks_description_text' | i18next }}
                </div>
            </div>
            <input type="radio" name="task-reassignment" />
        </label>
    </div>
</ham-modal>

<!-- Bulk Edit action bar -->
<bulk-edit-action-bar
    *ngIf="selectedCompanies?.size > 0"
    [selectedCount]="selectedCompanies?.size"
    [actions]="bulkActions"
    [deleteAction]="deleteAction"
    textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
    [globalPosition]="true"
    (actionClicked)="onActionClicked($event)"
    deleteActionIcon="assets/hamIcons/moon-outline.svg"
></bulk-edit-action-bar>

<!-- Ham Modal for Assignee Change -->
<ham-modal
    *ngIf="openBulkEditAssignee"
    [title]="'aumico_company_assignee_change_dialog_title' | i18next : { count: selectedCompanies.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditAssignee = false; this.bulkEditAssigneeControl.reset()"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditAssigneeConfirm()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_company_assignee_change_dialog_select_new_assignee' | i18next"
        [options]="organizationUsers"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_company_assignee_change_dialog_add_assignee_for_selected_tasks' | i18next"
        [formControl]="bulkEditAssigneeControl"
/></ham-modal>

<!-- Ham Modal for Clerk Change -->
<ham-modal
    *ngIf="openBulkEditClerk"
    [title]="'aumico_company_clerk_change_dialog_title' | i18next : { count: selectedCompanies.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditClerk = false; this.bulkEditClerkControl.reset()"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditClerkConfirm()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_company_clerk_change_dialog_select_new_clerk' | i18next"
        [options]="organizationUsers"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_company_clerk_change_dialog_add_clerk_for_selected_tasks' | i18next"
        [formControl]="bulkEditClerkControl"
/></ham-modal>

<!-- HamModal for Bulk Disable -->
<ham-confirm-decline-modal
    *ngIf="openBulkDisableConfirmationDialog"
    (cancel)="cancelBulkDisable()"
    (action)="confirmBulkDisable()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_companies_inactivate_dialog_ok' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_app_cpmm_companies_disable_confirmation' | i18next : { count: selectedCompanies.size }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<!-- Bulk Create Financial Year Modal -->
<bulk-create-financial-year-modal
    *ngIf="showBulkCreateFinancialYearModal"
    [previewData]="bulkCreatePreviewData"
    [loading]="bulkCreateLoading"
    [jobStatus]="bulkCreateJobStatus"
    [progress]="bulkCreateProgress"
    (confirm)="onBulkCreateFinancialYearConfirm()"
    (cancel)="onBulkCreateFinancialYearCancel()"
></bulk-create-financial-year-modal>
